import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {getCategoryName, getColorStatusTopic} from '../../../actions/delivery'
import Checkbox from '../../../components/checkbox';
import './ListTopic.scss';
import DropdownMenu from "../../../components/dropdown/DropdownMenu";

export const COPY_THIS_WORKSPACE = 'このワークスペースにコピー';
export const COPY_OTHER_WORKSPACE = '他のワークスペースにコピー';
export const DELETE = '削除';

const handleTextCategory = (value) => {
    if (value.category_name === 'game' && value.game) {
        const text = value.game;
        return `${text.game_date ? moment(text.game_date, 'YYYY/MM/DD').format('MM/DD') : ''} ${text.away_team ? text.away_team.team_name_s : ''} - ${text.home_team ? text.home_team.team_name_s : ''}`;
    }
    if(value.category_name === 'team' && value.team) {
        return value.team.team_name_s ? value.team.team_name_s : '';
    }
    if(value.category_name === 'player' && value.player) {
        return value.player.player_name ? value.player.player_name : '';
    }
    return '';
};

function ListTopic(props) {
    const {list, checkedValues, onColumnClick, hideDelete} = props;

    const handleAction = useCallback((option, idx, item) => {
        props.onChooseAction(option, idx, item);
    }, [list])

    return <div className={'admin-delivery-list-topic'}>
        <table>
            <thead>
            <tr>
                <th/>
                <th><span>タイトル</span></th>
                <th><span>カテゴリー</span></th>
                <th><span>対象</span></th>
                <th><span>作成日時</span></th>
                <th><span>更新日時</span></th>
                <th><span>ステータス</span></th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {list.map((item, index) => {
                return <tr key={index}>
                    <td>
                        <Checkbox checked={checkedValues[index]} onChange={() => props.onCheckboxChange(index)}/>
                    </td>
                    <td onClick={() => onColumnClick('title', item, index)} style={{cursor: 'pointer'}}>
                        {item.title}
                    </td>
                    <td onClick={() => onColumnClick('category', item, index)} style={{cursor: 'pointer'}}>
                        {getCategoryName(item.category_name)}
                    </td>
                    <td>{handleTextCategory(item)}</td>
                    <td>{moment(item.created_at, 'YYYY-MM-DD HH:SS').format('YYYY/MM/DD HH:SS')}</td>
                    <td>{moment(item.updated_at, 'YYYY-MM-DD HH:SS').format('YYYY/MM/DD HH:SS')}</td>
                    <td>
                        <span style={{
                            backgroundColor: getColorStatusTopic(item.status.id),
                            borderRadius: 4,
                            width: 8,
                            height: 8,
                            display: 'inline-block',
                            marginRight: 5
                        }}/>
                        {item.status.name}
                    </td>
                    <td>
                        <DropdownMenu position={'right'}
                                      list={
                                          hideDelete
                                              ? [
                                                  COPY_THIS_WORKSPACE,
                                                  COPY_OTHER_WORKSPACE,
                                              ]
                                              : [
                                                  COPY_THIS_WORKSPACE,
                                                  COPY_OTHER_WORKSPACE,
                                                  DELETE,
                                              ]
                                      }

                                      getOptionLabel={(option) => option}
                                      onChange={(option, idx) => handleAction(option, idx, item)}>
                            <img src="/img/more_vert_24px.png" className={'more-button-action'} alt="more"/>
                        </DropdownMenu>
                    </td>
                </tr>
            })}
            </tbody>
        </table>
    </div>
}

ListTopic.propTypes = {
    list: PropTypes.array.isRequired,
    onChooseAction: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    onColumnClick: PropTypes.func.isRequired,
};

export default ListTopic;
